import { DAPI_HOST } from '../../config/index';

const getConsentFormSignaturesUrl = () => `${DAPI_HOST}/v2/consent-form-signatures`;

export { getConsentFormSignaturesUrl };
